import React, { useEffect } from 'react';
import './Launchwebtrader.css';

const LaunchWebTrader = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const platforms = [
    { icon: '🖥️', name: 'MetaTrader 4', description: "The world's most popular trading platform with advanced charting" },
    { icon: '📊', name: 'MetaTrader 5', description: 'Next-generation platform with more timeframes and indicators' },
    { icon: '📈', name: 'TradingView', description: 'Cloud-based platform with advanced charting tools' },
    { icon: '⚡', name: 'cTrader', description: 'Advanced ECN platform designed for professional traders' }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span>
          <span>Back to Home</span>
        </button>

        <h1>Launch Web Trader</h1>
        <p className="subtitle">Access powerful trading platforms from any device, anywhere. No download required for web platforms.</p>

        <div className="platforms-grid">
          {platforms.map((platform, index) => (
            <div key={index} className="platform-card">
              <div className="platform-icon">{platform.icon}</div>
              <h3>{platform.name}</h3>
              <p>{platform.description}</p>
              <button className="launch-button">Launch WebTrader</button>
              <button className="launch-button secondary">Download Desktop</button>
            </div>
          ))}
        </div>

        <div className="features-section">
          <h2>Platform Features</h2>
          <div className="features-grid">
            <div className="feature-item">
              <h4>⚡ Fast Execution</h4>
              <p>Execute orders in milliseconds</p>
            </div>
            <div className="feature-item">
              <h4>📊 Advanced Charts</h4>
              <p>Access hundreds of technical indicators</p>
            </div>
            <div className="feature-item">
              <h4>🤖 Automated Trading</h4>
              <p>Use expert advisors and trading robots</p>
            </div>
            <div className="feature-item">
              <h4>📱 Mobile Trading</h4>
              <p>Trade on the go with mobile apps</p>
            </div>
          </div>
        </div>

        <div className="login-section">
          <h2>Login to Web Trader</h2>
          <form>
            <div className="form-group">
              <label htmlFor="loginNumber">Login Number</label>
              <input type="text" id="loginNumber" placeholder="Enter your trading account number" />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input type="password" id="password" placeholder="Enter your password" />
            </div>
            <button type="submit" className="submit-btn">Login to WebTrader</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LaunchWebTrader;